module.exports = __webpack_public_path__ + "static/media/spreader_manuals.84951d12.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/spreader_manuals.svg
// module id = 1100
// module chunks = 36